import type { TypedAction } from '../types';

import {
  GET_JOB_SEARCH_ASSIST_SUCCESS,
  GET_JOB_SEARCH_ASSIST_ERROR,
  type JobSearchAssistState,
  GET_JOB_SEARCH_ASSIST_LOADING,
} from './types';

export const initialState: JobSearchAssistState = {
  pills: [],
  isLoading: false,
};

export default function reducer(
  state: JobSearchAssistState = initialState,
  action: TypedAction,
): JobSearchAssistState {
  switch (action.type) {
    case GET_JOB_SEARCH_ASSIST_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case GET_JOB_SEARCH_ASSIST_SUCCESS: {
      const { pills } = action.payload;
      return {
        ...state,
        pills,
        isLoading: false,
      };
    }

    case GET_JOB_SEARCH_ASSIST_ERROR: {
      return {
        ...state,
        pills: [],
        isLoading: false,
      };
    }

    default:
      return state;
  }
}
